var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-bold is-fullheight",class:_vm.colorScheme},[_c('div',{staticClass:"hero-head"},[_c('FrequentList'),_c('QuickList')],1),_c('div',{staticClass:"hero-body"})])}
var staticRenderFns = []

export { render, staticRenderFns }